module.exports = __webpack_public_path__ + "img/Tøj,-Sko-og-Acessories.7d972fa5.jpg";